// ----------------------------------------------------------------------------
// Component: Timeline Slider
// ----------------------------------------------------------------------------
//
// A timeline slider with Content Panel block
//
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------
import $ from 'jquery';
import Swiper, { Navigation, Pagination, A11y } from 'swiper';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/a11y';
import './_featured-products-slider.scss';



// -------------------------------------
// Variables
// -------------------------------------

// -------------------------------------
// Hooks
// -------------------------------------
function handleSlides(swiperEl) {
    swiperEl.slides.forEach(function(slide, index) {
        let slideLink = slide.querySelector('a');
        slideLink.addEventListener('focus', function(e) {
            swiperEl.slideTo(index);
        })
    });
}

$(function() {
    $(".carousel--featured-products-slider").each(function(index, element){
        var $this = $(this);

        // Generate unique class for each collection list slider
        $this.addClass("featured-products-slider-instance-" + index);

        // Generate unique btn classes for slider arrows
        $this.parents('.featured-products-slider').find(".swiper-button-prev").addClass("featured-products-slider-btn-prev-" + index);
        $this.parents('.featured-products-slider').find(".swiper-button-next").addClass("featured-products-slider-btn-next-" + index);

        var swiper = new Swiper(".featured-products-slider-instance-" + index, {
            // Optional parameters
            modules: [Navigation, Pagination, A11y],
            slidesPerView: 1,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.

            // // Navigation arrows
            navigation: {
              nextEl: ".featured-products-slider-btn-next-" + index,
              prevEl: ".featured-products-slider-btn-prev-" + index
            },

            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: 'true'
            },
        });

        swiper.slides.forEach(function(slide, index) {
            let slideLink = slide.querySelector('a');
            slideLink.addEventListener('focus', function(e) {
                swiper.slideTo(index);
            })
        });
    });
});
